import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Message = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M5.002 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7l-5 3v-3h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='square'
          strokeLinejoin='round'
        />
        <path
          d='M6.625 11a.875.875 0 1 0 1.75 0 .875.875 0 0 0-1.75 0m4.5 0a.875.875 0 1 0 1.75 0 .875.875 0 0 0-1.75 0m4.5 0a.875.875 0 1 0 1.75 0 .875.875 0 0 0-1.75 0'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.75'
          strokeLinecap='square'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.252 6a2.75 2.75 0 0 1 2.75-2.75h14A2.75 2.75 0 0 1 21.752 6v10a2.75 2.75 0 0 1-2.75 2.75H12.21l-4.822 2.893A.75.75 0 0 1 6.252 21v-2.25h-1.25A2.75 2.75 0 0 1 2.252 16zM7.5 12.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5'
        fill='currentColor'
      />
    )}
  </IconBase>
);
